export default __webpack_public_path__ + "03836d11a623b4cf2a96514fcbe3d559.svg";